export default function PerforatedDivider() {
  return (
    <div className="z-perforated">
      <div className="z-perforated-line" />
    </div>
  );
}
